// Where a security incident photo lives (mig 20261022050000). One definition for
// the capture/detail uploader and the offline queue's uploader, so the path
// convention the bucket policy keys on cannot drift between them.

export const SECURITY_PHOTO_BUCKET = 'security-photos'

/** `incident/<incident>/q-<photo>.jpg`, to go under the tenant prefix (tenantPath adds it).
 *  Keyed on client-minted ids, so a queued replay overwrites its own object. */
export function incidentQueuedPhotoKey(incidentId: string, photoId: string): string {
  return `incident/${incidentId}/q-${photoId}.jpg`
}
